(function () {
  var STORAGE_KEY = 'effilo_shipping_pincode';
  var PIN_RE = /^[1-9][0-9]{5}$/;
  var STATE_CODES = {
    'andaman and nicobar islands': 'AN',
    'andhra pradesh': 'AP',
    'arunachal pradesh': 'AR',
    assam: 'AS',
    bihar: 'BR',
    chandigarh: 'CH',
    chhattisgarh: 'CG',
    'dadra and nagar haveli': 'DN',
    'dadra and nagar haveli and daman and diu': 'DH',
    'daman and diu': 'DD',
    delhi: 'DL',
    'new delhi': 'DL',
    goa: 'GA',
    gujarat: 'GJ',
    haryana: 'HR',
    'himachal pradesh': 'HP',
    'jammu and kashmir': 'JK',
    jharkhand: 'JH',
    karnataka: 'KA',
    kerala: 'KL',
    ladakh: 'LA',
    lakshadweep: 'LD',
    'madhya pradesh': 'MP',
    maharashtra: 'MH',
    manipur: 'MN',
    meghalaya: 'ML',
    mizoram: 'MZ',
    nagaland: 'NL',
    odisha: 'OR',
    orissa: 'OR',
    puducherry: 'PY',
    pondicherry: 'PY',
    punjab: 'PB',
    rajasthan: 'RJ',
    sikkim: 'SK',
    'tamil nadu': 'TN',
    telangana: 'TS',
    tripura: 'TR',
    'uttar pradesh': 'UP',
    uttarakhand: 'UK',
    uttaranchal: 'UK',
    'west bengal': 'WB',
  };
  var METRO_STATES = {
    DL: true,
    MH: true,
    KA: true,
    TN: true,
    TS: true,
    WB: true,
    GJ: true,
  };

  function rootUrl() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function sleep(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function requestError(message, code) {
    var error = new Error(message);
    error.code = code || 'REQUEST_FAILED';
    return error;
  }

  async function responseJson(response) {
    try {
      return await response.json();
    } catch (error) {
      return null;
    }
  }

  function normalizeState(state) {
    return String(state || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function provinceCode(state) {
    return STATE_CODES[normalizeState(state)] || '';
  }

  var WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /**
   * Formats a Date as "Mon 9 Jun" (no locale commas).
   * @param {Date} date
   * @returns {string}
   */
  function formatShortDate(date) {
    if (!(date instanceof Date) || isNaN(date.getTime())) return '';
    return WEEKDAYS[date.getDay()] + ' ' + date.getDate() + ' ' + MONTHS[date.getMonth()];
  }

  /**
   * S10-3b: today's calendar date in India (UTC+5:30, no daylight saving), whatever time zone
   * the visitor's device is set to. Returned as a local Date at noon, so adding days and the
   * local getters in formatShortDate stay on the intended calendar day.
   * @returns {Date}
   */
  function indiaToday() {
    var india = new Date(Date.now() + 330 * 60 * 1000);
    return new Date(india.getUTCFullYear(), india.getUTCMonth(), india.getUTCDate(), 12);
  }

  /**
   * Builds a delivery window from today (India date) plus min/max calendar days.
   * @param {number} minDays
   * @param {number} maxDays
   * @returns {string}
   */
  function formatDeliveryWindow(minDays, maxDays) {
    var start = indiaToday();
    var end = indiaToday();
    start.setDate(start.getDate() + minDays);
    end.setDate(end.getDate() + maxDays);
    return formatShortDate(start) + ' – ' + formatShortDate(end);
  }

  /**
   * Estimates delivery dates from a state code. Metros: 2–4 days; others: 4–7.
   * @param {string} [province]
   * @returns {string}
   */
  function estimateDeliveryLabel(province) {
    var days = METRO_STATES[province] ? [2, 4] : [4, 7];
    return formatDeliveryWindow(days[0], days[1]);
  }

  /**
   * Default India-wide estimate shown on the card.
   * S10-3b: the window (calendar days from today, India date) is set in ONE place,
   * snippets/product-effilo-pdp.liquid, which prints it on the card as data-delivery-min-days
   * and data-delivery-max-days. No day numbers for the card live in this file.
   * If the attributes are missing, keep the dates the server printed.
   * @param {Element} root
   * @returns {string}
   */
  function defaultIndiaDeliveryLabel(root) {
    var minDays = parseInt(root.getAttribute('data-delivery-min-days'), 10);
    var maxDays = parseInt(root.getAttribute('data-delivery-max-days'), 10);
    if (isNaN(minDays) || isNaN(maxDays)) return root.getAttribute('data-fallback-title') || '';
    return formatDeliveryWindow(minDays, maxDays);
  }

  function formatMoney(priceString) {
    var cents = Math.round(parseFloat(priceString || '0', 10) * 100);
    if (!isFinite(cents) || cents <= 0) return 'Free';
    if (typeof window.formatEffiloMoney === 'function') {
      return window.formatEffiloMoney(cents);
    }
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  /**
   * Formats a shipping-rate ISO date for the PDP title.
   * @param {string} iso
   * @returns {string}
   */
  function formatDateLabel(iso) {
    if (!iso) return '';
    return formatShortDate(new Date(iso));
  }

  function deliveryLabel(rate, address) {
    if (rate && rate.delivery_range && rate.delivery_range.length === 2) {
      var start = formatDateLabel(rate.delivery_range[0]);
      var end = formatDateLabel(rate.delivery_range[1]);
      if (start && end) return start + ' – ' + end;
    }

    if (rate && rate.delivery_date) {
      var single = formatDateLabel(rate.delivery_date);
      if (single) return single;
    }

    if (rate && rate.delivery_days && rate.delivery_days.length) {
      var min = Math.min.apply(null, rate.delivery_days);
      var max = Math.max.apply(null, rate.delivery_days);
      if (min === max) return 'Delivery in ' + min + ' day' + (min === 1 ? '' : 's');
      return 'Delivery in ' + min + '–' + max + ' days';
    }

    return address && address.province ? estimateDeliveryLabel(address.province) : '';
  }

  function rateName(rate) {
    return (rate && (rate.presentment_name || rate.name)) || 'Standard shipping';
  }

  function getVariantId(root) {
    var pdp = root.closest('[data-effilo-pdp]') || document;
    var input = pdp.querySelector('form[data-product-form] input[name="id"]');
    if (input && input.value) return input.value;
    input = pdp.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input && input.value ? input.value : null;
  }

  function addressParams(country, zip, address) {
    var params = new URLSearchParams();
    params.set('shipping_address[country]', country);
    params.set('shipping_address[zip]', zip);
    params.set('shipping_address[province]', address.province);
    if (address.city) params.set('shipping_address[city]', address.city);
    return params;
  }

  async function fetchPincodeAddress(pin) {
    var controller = new AbortController();
    var timeout = window.setTimeout(function () {
      controller.abort();
    }, 7000);

    try {
      var response = await fetch('https://api.postalpincode.in/pincode/' + encodeURIComponent(pin), {
        headers: { Accept: 'application/json' },
        signal: controller.signal,
      });
      if (!response.ok) throw requestError('Pincode service is temporarily unavailable.');

      var data = await responseJson(response);
      var payload = Array.isArray(data) ? data[0] : null;
      var offices = payload && Array.isArray(payload.PostOffice) ? payload.PostOffice : [];
      if (!payload || payload.Status !== 'Success' || !offices.length) {
        throw requestError('This pincode could not be found.', 'INVALID_PINCODE');
      }

      var office =
        offices.find(function (item) {
          return item && item.DeliveryStatus === 'Delivery';
        }) || offices[0];
      var province = provinceCode(office.State);
      if (!province) {
        throw requestError('Could not map this pincode to a delivery state.');
      }

      return {
        city: office.Name || office.District || '',
        district: office.District || '',
        state: office.State || '',
        province: province,
        deliverable: offices.some(function (item) {
          return item && item.DeliveryStatus === 'Delivery';
        }),
      };
    } catch (error) {
      if (error && error.code) throw error;
      throw requestError('Pincode service is temporarily unavailable.');
    } finally {
      window.clearTimeout(timeout);
    }
  }

  async function ensureCartHasItem(variantId) {
    var cart = await fetch(rootUrl() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      return res.json();
    });

    if (cart.item_count > 0 || !variantId) return null;

    var added = await fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    }).then(function (res) {
      if (!res.ok) throw requestError('Could not prepare cart for shipping check');
      return res.json();
    });

    return added.key || null;
  }

  async function removeTempItem(key) {
    if (!key) return;
    try {
      await fetch(rootUrl() + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });
    } catch (err) {
      /* ignore restore errors */
    }
  }

  function shippingApiError(data, fallback) {
    if (!data || typeof data !== 'object') return fallback;
    if (Array.isArray(data.province) && data.province.length) return data.province[0];
    if (Array.isArray(data.error) && data.error.length) return data.error[0];
    if (typeof data.error === 'string') return data.error;
    return fallback;
  }

  async function fetchShippingRates(country, zip, address) {
    var params = addressParams(country, zip, address);
    var query = params.toString();

    var prepareResponse = await fetch(rootUrl() + 'cart/prepare_shipping_rates.json?' + query, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    var prepareData = await responseJson(prepareResponse);
    if (!prepareResponse.ok) {
      throw requestError(
        shippingApiError(prepareData, 'Shopify could not calculate delivery for this address.')
      );
    }

    for (var attempt = 0; attempt < 20; attempt += 1) {
      var asyncRes = await fetch(rootUrl() + 'cart/async_shipping_rates.json?' + query, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      var asyncData = await responseJson(asyncRes);
      if (!asyncRes.ok) {
        throw requestError(
          shippingApiError(asyncData, 'Shopify could not calculate delivery for this address.')
        );
      }
      if (asyncData && Array.isArray(asyncData.shipping_rates)) {
        return asyncData.shipping_rates;
      }
      await sleep(300);
    }

    var syncRes = await fetch(rootUrl() + 'cart/shipping_rates.json?' + query, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    var syncData = await responseJson(syncRes);
    if (!syncRes.ok) {
      throw requestError(shippingApiError(syncData, 'Shipping rates are unavailable.'));
    }
    return syncData && Array.isArray(syncData.shipping_rates) ? syncData.shipping_rates : [];
  }

  function locationLabel(address, pin) {
    var location = [address.district || address.city, address.state].filter(Boolean).join(', ');
    return location ? location + ' (' + pin + ')' : pin;
  }

  function setStatus(el, message, type) {
    if (!el) return;
    el.textContent = message || '';
    el.classList.remove('is-error', 'is-success', 'is-loading');
    if (type) el.classList.add('is-' + type);
  }

  function renderRates(listEl, rates, address) {
    if (!listEl) return;
    listEl.innerHTML = '';
    if (!rates.length) {
      listEl.hidden = true;
      return;
    }

    rates.forEach(function (rate) {
      var li = document.createElement('li');
      li.className = 'effilo-pdp__shipping-rate';

      var name = document.createElement('span');
      name.className = 'effilo-pdp__shipping-rate-name';
      name.textContent = rateName(rate);

      var meta = document.createElement('span');
      meta.className = 'effilo-pdp__shipping-rate-meta';
      meta.textContent = deliveryLabel(rate, address) || 'Ships across India';

      var price = document.createElement('strong');
      price.className = 'effilo-pdp__shipping-rate-price';
      price.textContent = formatMoney(rate.price);

      li.appendChild(name);
      li.appendChild(meta);
      li.appendChild(price);
      listEl.appendChild(li);
    });

    listEl.hidden = false;
  }

  function applyPrimaryRate(root, rate, fallback, address) {
    var titleEl = root.querySelector('[data-effilo-shipping-title]');
    var copyEl = root.querySelector('[data-effilo-shipping-copy]');
    var priceEl = root.querySelector('[data-effilo-shipping-price]');

    if (!rate) {
      if (titleEl) titleEl.textContent = fallback.title;
      if (copyEl) copyEl.textContent = fallback.copy;
      if (priceEl) priceEl.textContent = fallback.price;
      return;
    }

    if (titleEl) titleEl.textContent = deliveryLabel(rate, address) || rateName(rate);
    if (copyEl) {
      copyEl.textContent = address
        ? rateName(rate) + ' · ' + (address.district || address.city) + ', ' + address.state
        : rateName(rate) + ' · Ships across India';
    }
    if (priceEl) priceEl.textContent = formatMoney(rate.price);
  }

  function initShipping(root) {
    if (!root || root.dataset.effiloShippingInit === 'true') return;
    root.dataset.effiloShippingInit = 'true';

    var country = root.getAttribute('data-country') || 'IN';
    var fallback = {
      title: defaultIndiaDeliveryLabel(root),
      copy: root.getAttribute('data-fallback-copy') || 'Standard shipment across India',
      price: root.getAttribute('data-fallback-price') || 'Free',
    };
    applyPrimaryRate(root, null, fallback, null);

    var input = root.querySelector('[data-effilo-shipping-pincode]');
    var submit = root.querySelector('[data-effilo-shipping-submit]');
    var status = root.querySelector('[data-effilo-shipping-status]');
    var ratesEl = root.querySelector('[data-effilo-shipping-rates]');
    var toggle = root.querySelector('[data-effilo-shipping-toggle]');
    var checking = false;

    async function check() {
      if (checking || !input) return;

      var pin = String(input.value || '').replace(/\D/g, '').slice(0, 6);
      input.value = pin;

      if (!PIN_RE.test(pin)) {
        setStatus(status, 'Enter a valid 6-digit Indian pincode.', 'error');
        renderRates(ratesEl, [], null);
        if (toggle) toggle.hidden = true;
        applyPrimaryRate(root, null, fallback, null);
        return;
      }

      checking = true;
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Checking…';
      }
      setStatus(status, 'Checking delivery options…', 'loading');

      var tempKey = null;
      try {
        var address = await fetchPincodeAddress(pin);
        if (!address.deliverable) {
          throw requestError('Delivery is not available for this pincode.', 'INVALID_PINCODE');
        }

        tempKey = await ensureCartHasItem(getVariantId(root));
        var rates = await fetchShippingRates(country, pin, address);
        try {
          window.localStorage.setItem(STORAGE_KEY, pin);
        } catch (err) {
          /* ignore */
        }

        if (!rates.length) {
          applyPrimaryRate(root, null, fallback, null);
          renderRates(ratesEl, [], null);
          if (toggle) toggle.hidden = true;
          setStatus(status, 'No shipping rates for ' + locationLabel(address, pin) + '.', 'error');
          return;
        }

        applyPrimaryRate(root, rates[0], fallback, address);
        renderRates(ratesEl, rates, address);
        if (toggle) {
          toggle.hidden = rates.length < 2;
          toggle.setAttribute('aria-expanded', 'true');
        }
        ratesEl.hidden = false;
        setStatus(
          status,
          'Delivery available to ' +
            locationLabel(address, pin) +
            ' by ' +
            deliveryLabel(rates[0], address) +
            '.',
          'success'
        );
      } catch (err) {
        applyPrimaryRate(root, null, fallback, null);
        renderRates(ratesEl, [], null);
        if (toggle) toggle.hidden = true;
        setStatus(
          status,
          err && err.message ? err.message : 'Could not fetch shipping rates. Please try again.',
          'error'
        );
      } finally {
        await removeTempItem(tempKey);
        checking = false;
        if (submit) {
          submit.disabled = false;
          submit.textContent = 'Check';
        }
      }
    }

    if (submit) submit.addEventListener('click', check);
    if (input) {
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          check();
        }
      });
      input.addEventListener('input', function () {
        input.value = String(input.value || '').replace(/\D/g, '').slice(0, 6);
      });
    }

    if (toggle && ratesEl) {
      toggle.addEventListener('click', function () {
        var open = ratesEl.hidden;
        ratesEl.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    try {
      var saved = window.localStorage.getItem(STORAGE_KEY);
      if (saved && PIN_RE.test(saved) && input) {
        input.value = saved;
        check();
      }
    } catch (err) {
      /* ignore */
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-effilo-shipping]').forEach(initShipping);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
